import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { ColoredDot } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'

export const KpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1rem;
  margin: 2rem 0;

  @media (max-width: 70rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const DeptMatrixSection = styled.div`
  margin-bottom: 1rem;
`

export const TrendArrow = styled.span<{ $color: string }>`
  color: ${(props) => props.$color};
  font-size: ${tokens.font.label};
  line-height: 1;
`

export const ColumnsWrap = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 65fr) minmax(0, 35fr);
  gap: 1rem;
  align-items: start;

  @media (max-width: 70rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const PlanList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const PlanCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  cursor: pointer;
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.glowBorder};
  }
`

export const AlertList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const AlertRow = styled.div<{ $color: string }>`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem;
  border-left: 3px solid ${(props) => props.$color};
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
`

export const AlertDot = styled(ColoredDot)`
  min-width: 0.5rem;
  max-width: 0.5rem;
  min-height: 0.5rem;
  max-height: 0.5rem;
  margin-top: 0.375rem;
  box-shadow: 0 0 8px ${(props) => props.color};
`

export const AlertTime = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  white-space: nowrap;
`

export const EmptyStateWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem 1rem;
  text-align: center;
`

export const QuickLinksStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
`

export const QuickLinkChip = styled(Link)`
  padding: 0.25rem 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: 999px;
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
  background: ${tokens.surface.inset};
  transition: all ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${tokens.accent.onDark};
    border-color: ${tokens.accent.glowBorder};
  }
`
